{
  "blocks": [
    {
      "id": "dp-estradiol-level",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "Estradiol",
      "body": {
        "value": "Varies",
        "unit": "pg/mL",
        "normalRange": "Depends on cycle phase, protocol, and follicle response",
        "interpretation": "Estradiol is interpreted as a trend alongside follicle growth and protocol timing. During stimulation, each mature follicle often contributes roughly 200-300 pg/mL, but clinics look at the whole pattern rather than one exact number.",
        "aliases": ["E2", "Estradiol (E2)", "Estrogen"],
        "sampleTypes": ["blood"],
        "metricKey": "estradiol"
      }
    },
    {
      "id": "dp-lh-level",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "LH",
      "body": {
        "value": "Varies",
        "unit": "mIU/mL",
        "normalRange": "Depends on cycle phase and protocol",
        "interpretation": "LH is usually interpreted around ovulation timing, suppression, or trigger planning.",
        "aliases": ["Luteinizing hormone"],
        "sampleTypes": ["blood"],
        "metricKey": "lh"
      }
    },
    {
      "id": "dp-fsh-level",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "FSH",
      "body": {
        "value": "Cycle-day dependent",
        "unit": "mIU/mL",
        "normalRange": "Usually interpreted from an early-cycle baseline draw",
        "interpretation": "Baseline FSH is interpreted with estradiol, AMH, AFC, age, and treatment context. A rising day-3 FSH trend can be a signal to move faster, especially when reserve is already low.",
        "aliases": ["Follicle-stimulating hormone"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-progesterone-level",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "Progesterone",
      "body": {
        "value": "Phase-specific",
        "unit": "ng/mL",
        "normalRange": "Follicular 0.1-1.5 / Ovulation 1-3 / Mid-luteal (7DPO) 5-20 / Postmenopausal <0.5",
        "interpretation": "Progesterone is timing-sensitive and should be interpreted with ovulation timing or the medication schedule. A mid-luteal check is usually drawn about 7 days after ovulation; >3 ng/mL confirms ovulation occurred. Progesterone is pulsatile (oscillates 5-40 ng/mL within hours), so no single value reliably diagnoses luteal phase deficiency per ASRM 2021. In medicated FET cycles, ~10 ng/mL is a commonly used adequacy threshold.",
        "aliases": ["P4"],
        "sampleTypes": ["blood"],
        "metricKey": "progesterone"
      }
    },
    {
      "id": "dp-tsh-level",
      "kind": "data-point",
      "tags": ["testing", "her", "thyroid"],
      "title": "TSH",
      "body": {
        "value": "Clinic target varies",
        "unit": "mIU/L",
        "normalRange": "Fertility clinics often use a tighter preconception target, commonly below 2.5 mIU/L when trying to conceive",
        "interpretation": "TSH is interpreted with thyroid history, symptoms, free T4, medication use, and pregnancy plans. If elevated, medication often changes the level within 6-8 weeks.",
        "aliases": ["Thyroid-stimulating hormone"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-free-t4-level",
      "kind": "data-point",
      "tags": ["testing", "her", "thyroid"],
      "title": "Free T4",
      "body": {
        "value": "Lab-dependent",
        "unit": "ng/dL",
        "normalRange": "Reference ranges vary by lab",
        "interpretation": "Free T4 helps clarify thyroid status when TSH is abnormal or when monitoring treatment.",
        "aliases": ["T4", "FT4", "Thyroxine"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-free-t3-level",
      "kind": "data-point",
      "tags": ["testing", "her", "thyroid"],
      "title": "Free T3",
      "body": {
        "value": "Lab-dependent",
        "unit": "pg/mL",
        "normalRange": "Reference ranges vary by lab",
        "interpretation": "Free T3 is sometimes added when the care team needs a fuller thyroid picture.",
        "aliases": ["T3", "FT3", "Triiodothyronine"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-vitamin-d-level",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "nutritional"],
      "title": "Vitamin D",
      "body": {
        "value": "30-40+",
        "unit": "ng/mL",
        "normalRange": "Targets vary by clinic and medical history; some fertility programs aim above 40 ng/mL",
        "interpretation": "Vitamin D is interpreted with supplementation, diet, sun exposure, and overall health context. Deficiency is common and often correctable over about 8 weeks of supplementation.",
        "aliases": ["25-OH vitamin D", "25-hydroxy vitamin D"],
        "sampleTypes": ["blood"],
        "metricKey": "vitamin-d"
      }
    },
    {
      "id": "dp-beta-hcg-level",
      "kind": "data-point",
      "tags": ["testing", "her", "post-cycle"],
      "title": "Beta hCG",
      "body": {
        "value": "Trend matters",
        "unit": "mIU/mL",
        "normalRange": "Positive thresholds vary by lab and timing",
        "interpretation": "Beta hCG is interpreted by timing after ovulation or transfer and by the repeat trend.",
        "aliases": ["hCG", "Beta-hCG", "Pregnancy hormone"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-prolactin-level",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "Prolactin",
      "body": {
        "value": "Lab-dependent",
        "unit": "ng/mL",
        "normalRange": "Reference ranges vary by lab and pregnancy/lactation status",
        "interpretation": "Prolactin is interpreted with symptoms, cycle regularity, stress, medications, and repeat timing.",
        "aliases": ["PRL"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-testosterone-level",
      "kind": "data-point",
      "tags": ["testing", "both-partners"],
      "title": "Testosterone",
      "body": {
        "value": "Lab-dependent",
        "unit": "ng/dL",
        "normalRange": "Reference ranges vary by sex, age, and lab",
        "interpretation": "Testosterone is interpreted with symptoms, cycle pattern, androgen markers, and context such as PMOS (ex PCOS).",
        "aliases": ["Total testosterone", "Free testosterone"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-dhea-s-level",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "DHEA-S",
      "body": {
        "value": "Lab-dependent",
        "unit": "mcg/dL",
        "normalRange": "Reference ranges vary by age and lab",
        "interpretation": "DHEA-S is interpreted with androgen symptoms, adrenal context, reserve markers, and supplement use.",
        "aliases": ["DHEA sulfate", "DHEA"],
        "sampleTypes": ["blood"]
      }
    },
    {
      "id": "dp-fasting-insulin",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "metabolic", "pmos"],
      "title": "Fasting insulin",
      "body": {
        "value": "Lab-dependent",
        "unit": "uIU/mL",
        "normalRange": "Reference ranges vary by lab and metabolic context",
        "interpretation": "Fasting insulin helps screen for insulin resistance, which is common with PMOS (ex PCOS) and can affect ovulation and egg quality. It can improve over 2-3 months with diet, exercise, inositol, metformin, or other clinician-guided changes.",
        "aliases": ["Insulin", "Fasting insulin level"],
        "sampleTypes": ["blood"],
        "metricKey": "fasting-insulin"
      }
    },
    {
      "id": "dp-hba1c",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "metabolic"],
      "title": "HbA1c",
      "body": {
        "value": "<5.7",
        "unit": "%",
        "normalRange": "Below 5.7% is generally considered non-diabetic",
        "interpretation": "HbA1c reflects average blood sugar over roughly 3 months. It is useful for preconception planning because glucose control affects pregnancy risk and can respond to metabolic changes over the same time window.",
        "aliases": ["A1c", "Hemoglobin A1c"],
        "sampleTypes": ["blood"],
        "metricKey": "hba1c"
      }
    },
    {
      "id": "dp-hs-crp",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "metabolic"],
      "title": "hs-CRP",
      "body": {
        "value": "Lower is better",
        "unit": "mg/L",
        "normalRange": "Reference ranges vary by lab and cardiovascular context",
        "interpretation": "hs-CRP is a systemic inflammation marker. In fertility planning, it is interpreted with infection, autoimmune, metabolic, and cardiovascular context rather than as a standalone implantation answer.",
        "aliases": ["High-sensitivity CRP", "C-reactive protein"],
        "sampleTypes": ["blood"],
        "metricKey": "hs-crp"
      }
    },
    {
      "id": "dp-homocysteine",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "nutritional"],
      "title": "Homocysteine",
      "body": {
        "value": "Lab-dependent",
        "unit": "umol/L",
        "normalRange": "Reference ranges vary by lab",
        "interpretation": "Homocysteine is interpreted with folate, B12, B6, thyroid, kidney, and cardiovascular context. When elevated, it may respond to methylfolate, B12, B6, and related nutrition changes over about 8 weeks.",
        "aliases": ["Total homocysteine"],
        "sampleTypes": ["blood"],
        "metricKey": "homocysteine"
      }
    },
    {
      "id": "dp-ferritin",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "nutritional"],
      "title": "Ferritin",
      "body": {
        "value": "Clinic target varies",
        "unit": "ng/mL",
        "normalRange": "Reference ranges vary by lab; some fertility programs aim above 40 ng/mL",
        "interpretation": "Ferritin reflects iron stores. It is interpreted with CBC, inflammation, bleeding history, diet, and pregnancy plans. Low ferritin often takes 3-6 months to rebuild with supplementation.",
        "aliases": ["Iron stores"],
        "sampleTypes": ["blood"],
        "metricKey": "ferritin"
      }
    },
    {
      "id": "dp-apob",
      "kind": "data-point",
      "tags": ["testing", "both-partners", "metabolic"],
      "title": "ApoB",
      "body": {
        "value": "Risk-dependent",
        "unit": "mg/dL",
        "normalRange": "Targets depend on cardiovascular risk",
        "interpretation": "ApoB estimates the number of atherogenic cholesterol particles and can be more informative than LDL alone. It is a useful preconception baseline because pregnancy increases cardiovascular load.",
        "aliases": ["Apolipoprotein B"],
        "sampleTypes": ["blood"],
        "metricKey": "apob"
      }
    },
    {
      "id": "dp-antiphospholipid-antibodies",
      "kind": "data-point",
      "tags": ["testing", "her", "autoimmune"],
      "title": "Antiphospholipid antibodies",
      "body": {
        "value": "Positive/negative",
        "normalRange": "Negative",
        "interpretation": "Antiphospholipid antibody testing can include anticardiolipin, lupus anticoagulant, and anti-beta-2 glycoprotein antibodies. A positive result usually needs repeat confirmation about 12 weeks later before diagnosing antiphospholipid syndrome.",
        "aliases": [
          "APS antibodies",
          "Anticardiolipin",
          "Lupus anticoagulant",
          "Anti-beta-2 glycoprotein"
        ],
        "sampleTypes": ["blood"],
        "metricKey": "antiphospholipid-antibodies"
      }
    },
    {
      "id": "dp-thrombophilia-genetics",
      "kind": "data-point",
      "tags": ["testing", "her", "genetic-screening"],
      "title": "Thrombophilia genetics",
      "body": {
        "value": "Variant-dependent",
        "normalRange": "No clinically relevant variant detected",
        "interpretation": "Inherited thrombophilia results such as Factor V Leiden or prothrombin gene mutation do not change over time, but they can affect pregnancy and IVF anticoagulation decisions in selected patients.",
        "aliases": [
          "Factor V Leiden",
          "Prothrombin gene mutation",
          "MTHFR",
          "Coagulation genetics"
        ],
        "sampleTypes": ["blood", "genetic"],
        "metricKey": "thrombophilia-genetics"
      }
    },
    {
      "id": "dp-follicle-count",
      "kind": "data-point",
      "tags": ["testing", "her", "afc"],
      "title": "Follicle count",
      "body": {
        "value": "Context-dependent",
        "unit": "total",
        "normalRange": "Depends on age, reserve, cycle phase, and protocol",
        "interpretation": "Follicle count is interpreted differently at baseline versus during stimulation monitoring. Baseline AFC can vary by about 2-5 follicles from cycle to cycle, while stimulation monitoring tracks how many follicles are actively growing.",
        "aliases": ["Follicles", "AFC", "Antral follicle count"],
        "sampleTypes": ["ultrasound"],
        "metricKey": "follicles"
      }
    },
    {
      "id": "dp-follicle-size",
      "kind": "data-point",
      "tags": ["testing", "her", "afc"],
      "title": "Follicle size",
      "body": {
        "value": "Measured in mm",
        "unit": "mm",
        "normalRange": "Expected size depends on stimulation day and protocol",
        "interpretation": "Follicle sizes help the clinic compare growth across the cohort and time trigger decisions. During stimulation, follicles often grow about 1-2 mm per day, and lead follicles around 18-20 mm are often considered trigger-ready depending on the protocol.",
        "aliases": ["Follicle sizes", "Lead follicle"],
        "sampleTypes": ["ultrasound"]
      }
    },
    {
      "id": "dp-endometrial-thickness",
      "kind": "data-point",
      "tags": ["testing", "her"],
      "title": "Endometrial lining",
      "body": {
        "value": "Measured in mm",
        "unit": "mm",
        "normalRange": "Depends on cycle phase and transfer protocol",
        "interpretation": "Lining thickness is interpreted with pattern, protocol, bleeding, and transfer timing. Many clinics look for at least about 7-8 mm and a trilaminar pattern before transfer planning.",
        "aliases": [
          "Endometrial thickness",
          "Lining thickness",
          "Uterine lining"
        ],
        "sampleTypes": ["ultrasound"],
        "metricKey": "lining"
      }
    },
    {
      "id": "dp-sperm-count",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Total sperm count",
      "body": {
        "value": "Lab-reported",
        "unit": "million per ejaculate",
        "normalRange": "Interpret against the lab's WHO 2021 reference range; total count and concentration are different measures",
        "interpretation": "Total sperm count is the number of sperm in the whole ejaculate. It should be read alongside concentration, motility, morphology, and semen volume rather than treated as a standalone fertility verdict.",
        "aliases": ["Sperm count", "Total sperm number"],
        "loincCodes": ["107184-4"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-concentration",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Sperm concentration",
      "body": {
        "value": "Lab-reported",
        "unit": "million/mL",
        "normalRange": "Interpret against the lab's WHO 2021 reference range",
        "interpretation": "Concentration is the number of sperm per millilitre of semen. It is related to total sperm count, but the two values should not be combined into one metric.",
        "aliases": ["Sperm density", "Sperm count per mL"],
        "loincCodes": ["9780-8"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-motility",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Progressive motility",
      "body": {
        "value": "Lab-reported",
        "unit": "%",
        "normalRange": "Interpret against the lab's WHO 2021 reference range",
        "interpretation": "Progressive motility is the percentage of sperm moving forward. The report should be read with non-progressive and immotile percentages so the categories add up to the full sample.",
        "aliases": ["Sperm motility", "Progressive sperm motility"],
        "loincCodes": ["14194-5"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-non-progressive-motility",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Non-progressive motility",
      "body": {
        "value": "Lab-reported",
        "unit": "%",
        "normalRange": "Reported alongside progressive motility and immotile sperm",
        "interpretation": "Non-progressive motility describes sperm that move without making forward progress. It is one part of the motility breakdown in a full semen analysis.",
        "aliases": ["Non-progressive sperm motility"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-morphology",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Sperm morphology",
      "body": {
        "value": "Lab-reported",
        "unit": "% normal forms",
        "normalRange": "Interpret against the lab's morphology criteria",
        "interpretation": "Morphology describes the percentage of sperm that meet the laboratory's shape criteria. It is one part of the overall pattern, not a standalone diagnosis.",
        "aliases": ["Normal forms"],
        "loincCodes": ["10622-9"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-agglutination",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Agglutination and aggregation",
      "body": {
        "value": "Lab-reported",
        "unit": "Grade or percentage",
        "normalRange": "Typically reported as absent, trace, or graded by the laboratory",
        "interpretation": "Agglutination and aggregation describe sperm sticking together or clustering with other material. The report should identify which pattern was observed and how it was graded.",
        "aliases": ["Agglutination", "Sperm aggregation"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-immotile",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Immotile sperm",
      "body": {
        "value": "Lab-reported",
        "unit": "%",
        "normalRange": "Reported alongside progressive and non-progressive motility",
        "interpretation": "Immotile sperm are not moving in the sample. This percentage completes the motility breakdown and should be interpreted with the other movement categories.",
        "aliases": ["Immotile sperm percentage"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-vitality",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Sperm vitality",
      "body": {
        "value": "Lab-reported",
        "unit": "%",
        "normalRange": "Interpret against the lab's WHO 2021 reference range",
        "interpretation": "Vitality is the percentage of sperm that are alive. It is what separates sperm that are alive but not swimming from sperm that are dead, so it is read together with the immotile percentage rather than on its own.",
        "aliases": ["Sperm viability", "Semen vitality"],
        "loincCodes": ["10613-8"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-semen-ph",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Semen pH",
      "body": {
        "value": "Lab-reported",
        "unit": "pH",
        "normalRange": "Interpret against the lab's WHO 2021 reference range",
        "interpretation": "Semen pH is one part of the sample's chemical profile and is interpreted with volume, appearance, and the rest of the analysis.",
        "aliases": ["Sperm pH"],
        "loincCodes": ["2752-4"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-semen-volume",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Semen volume",
      "body": {
        "value": "Lab-reported",
        "unit": "mL",
        "normalRange": "Interpret against the lab's WHO 2021 reference range",
        "interpretation": "Semen volume is measured in the collected sample. It helps put concentration and total sperm count in context and can be affected by collection conditions.",
        "aliases": ["Ejaculate volume", "Sperm volume"],
        "loincCodes": ["3160-9"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-antisperm-antibodies",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Antisperm antibodies",
      "body": {
        "value": "Assay-dependent",
        "unit": "Assay-specific",
        "normalRange": "Reference ranges depend on the laboratory method",
        "interpretation": "Antisperm antibody testing looks for immune proteins that bind to sperm. It is an advanced add-on and should be interpreted with the standard semen analysis and clinical history.",
        "aliases": ["Antisperm antibody test", "ASA"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-dna-fragmentation",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Sperm DNA fragmentation",
      "body": {
        "value": "Assay-dependent",
        "unit": "%",
        "normalRange": "Reference ranges depend on the lab assay",
        "interpretation": "DNA fragmentation is interpreted alongside semen analysis, history, and reproductive outcomes. It is an advanced add-on rather than an automatic part of every standard analysis.",
        "aliases": ["DFI", "DNA fragmentation index"],
        "loincCodes": ["104620-0"],
        "sampleTypes": ["semen"]
      }
    },
    {
      "id": "dp-sperm-dna-methylation",
      "kind": "data-point",
      "tags": ["testing", "his", "sperm", "semen-analysis"],
      "title": "Sperm DNA methylation",
      "body": {
        "value": "Assay-dependent",
        "unit": "Assay-specific",
        "normalRange": "Reference ranges depend on the laboratory method",
        "interpretation": "Sperm DNA methylation is an advanced assay that examines epigenetic patterns beyond the standard semen parameters. Results require assay-specific interpretation and should not be treated as a standalone fertility diagnosis.",
        "aliases": ["Epigenetic DNA methylation", "SpermEGT DNA methylation"],
        "sampleTypes": ["semen"]
      }
    }
  ],
  "relationships": [
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-fsh-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-lh-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-estradiol-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-progesterone-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-prolactin-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-testosterone-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-dhea-s-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-tsh-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-free-t4-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-free-t3-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-fasting-insulin",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-hba1c",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-hs-crp",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-homocysteine",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-vitamin-d-level",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-ferritin",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-apob",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-antiphospholipid-antibodies",
      "type": "data-for"
    },
    {
      "from": "test-comprehensive-biomarker-panel",
      "to": "dp-thrombophilia-genetics",
      "type": "data-for"
    },
    {
      "from": "test-lh",
      "to": "dp-lh-level",
      "type": "data-for"
    },
    {
      "from": "test-estradiol",
      "to": "dp-estradiol-level",
      "type": "data-for"
    },
    {
      "from": "test-general-bloodwork",
      "to": "dp-amh-level",
      "type": "data-for"
    },
    {
      "from": "test-general-bloodwork",
      "to": "dp-fsh-level",
      "type": "data-for"
    },
    {
      "from": "test-general-bloodwork",
      "to": "dp-estradiol-level",
      "type": "data-for"
    },
    {
      "from": "test-general-bloodwork",
      "to": "dp-lh-level",
      "type": "data-for"
    },
    {
      "from": "test-general-bloodwork",
      "to": "dp-progesterone-level",
      "type": "data-for"
    },
    {
      "from": "test-baseline-ultrasound",
      "to": "dp-follicle-count",
      "type": "data-for"
    },
    {
      "from": "test-baseline-ultrasound",
      "to": "dp-endometrial-thickness",
      "type": "data-for"
    },
    {
      "from": "test-afc",
      "to": "dp-follicle-count",
      "type": "data-for"
    },
    {
      "from": "test-monitoring-ultrasound",
      "to": "dp-follicle-count",
      "type": "data-for"
    },
    {
      "from": "test-monitoring-ultrasound",
      "to": "dp-follicle-size",
      "type": "data-for"
    },
    {
      "from": "test-monitoring-ultrasound",
      "to": "dp-endometrial-thickness",
      "type": "data-for"
    },
    {
      "from": "test-lining-check",
      "to": "dp-endometrial-thickness",
      "type": "data-for"
    },
    {
      "from": "test-fsh",
      "to": "dp-fsh-level",
      "type": "data-for"
    },
    {
      "from": "test-progesterone-check",
      "to": "dp-progesterone-level",
      "type": "data-for"
    },
    {
      "from": "test-beta-hcg",
      "to": "dp-beta-hcg-level",
      "type": "data-for"
    },
    {
      "from": "test-thyroid-panel",
      "to": "dp-tsh-level",
      "type": "data-for"
    },
    {
      "from": "test-thyroid-panel",
      "to": "dp-free-t4-level",
      "type": "data-for"
    },
    {
      "from": "test-thyroid-panel",
      "to": "dp-free-t3-level",
      "type": "data-for"
    },
    {
      "from": "test-prolactin",
      "to": "dp-prolactin-level",
      "type": "data-for"
    },
    {
      "from": "test-vitamin-d",
      "to": "dp-vitamin-d-level",
      "type": "data-for"
    }
  ],
  "localeVariants": []
}
